class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
 this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
        // 👉 NEW: Hover support
    this.summary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
     this.summary.addEventListener('mouseleave', this.onMouseLeave.bind(this));
     this.content.addEventListener('mouseleave',this.onMouseLeave.bind(this))
  }
  onMouseEnter() {
    clearTimeout(this.hoverTimeout);
    this.open();
  }

  onMouseLeave(event) {
    // 👉 IMPORTANT: don't close if moving inside the component
    if (this.contains(event.relatedTarget)) return;

    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
  open() {
    this.mainDetailsToggle.setAttribute('open', true);
  }


  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
